import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import './share.js'

const GoldBar = (props) => {
    
    const init = () => {
        // Setup social share menu
        const shareEl = barEl.querySelector('[data-share]');
        const shareToggleEl = barEl.querySelector('[data-share-toggle]');

        if(shareToggleEl) {
            shareToggleEl.addEventListener('click', function(){
                if(shareEl.classList.contains('cnn-bar__share--active')){
                    shareEl.classList.remove('cnn-bar__share--active');
                } else {
                    shareEl.classList.add('cnn-bar__share--active');
                }
            }, false);
        }

        // Set up scroll handler
        document.addEventListener('scroll', function() {
            window.requestAnimationFrame(onScroll);
        }, {passive: true});
    }

    const onScroll = () => {
        // Get current scroll position
        const sPos = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY;

        if(sPos < 30) {
            if(barEl.classList.contains('cnn-bar--fixed')) {
                barEl.classList.remove('cnn-bar--fixed');
            }
        } else {
            if(!barEl.classList.contains('cnn-bar--fixed')) {
                barEl.classList.add('cnn-bar--fixed');
            }
        }
    }

    
    let barEl;
    useEffect(() => {
        // Get main element
        barEl = document.getElementById('cnn-bar');
        if(barEl) {
            init();
        }
    })

    const usePrevious = (value) => {
        const ref = React.useRef()
        useEffect(() => { ref.current = value })
        return ref.current
    }

    const location = useLocation();
    const previousLocation = usePrevious(location);
    

    useEffect(() => {
        // Don't do this on initial page load
	    if (typeof previousLocation !== 'undefined') {
	    	window.s.pageName = 'cnn/adfeature' + window.location.pathname;
	    	window.s.pageURL = location.href;
	    	window.s.referrer = window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) + previousLocation.pathname;
	    	window.s.t();

	    	// Reset scroll tracking
	    	if (typeof window.uniqueTrackNames !== 'undefined') {
	    		window.uniqueTrackNames = [];
	    	}
	    }
    }, [location])

    return (
        <div className="template-container">
            <section className="cnn-bar__wrapper">
                <header className="cnn-bar" id="cnn-bar">
                    <div className="cnn-bar__row cnn-bar__row--black">
                        <a className="cnn-bar__back-link" href="https://edition.cnn.com" rel="noopener noreferrer">Back to CNN</a>
                    </div>

                    <div className="cnn-bar__row cnn-bar__row--gold">
                        <a className="cnn-bar__logo" href="https://edition.cnn.com" rel="noopener noreferrer">
                            <xml version="1.0" encoding="utf-8">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 440.6 440.6" xmlSpace="preserve">
                                    <rect style={{ fill: '#CB1517' }} width="440.6" height="440.6" />
                                    <path
                                        style={{ fill: '#FFFFFF' }}
                                        d="M89.5,220.3c0-18.5,15-33.6,33.6-33.6h25.5v-19h-25.7c-29,0-52.6,23.6-52.6,52.6c0,29,23.6,52.6,52.6,52.6
                                    l49.4,0c2.8,0,5-2.7,5-5v-97.4c0-5.4,3.4-9.9,8.4-11.3c4.3-1.2,10.3,0,14.3,6.8c0.2,0.3,12.3,21.2,30.8,53.1
                                    c14.5,25,29.5,50.9,29.8,51.4c1.6,2.6,3.7,3.9,5.7,3.3c1.3-0.3,2.8-1.6,2.8-3.9v-99.5c0-5.4,3.4-9.9,8.3-11.3
                                    c4.2-1.2,10.2,0,14.2,6.8c0.2,0.3,10.9,18.8,28.6,49.3c15.6,26.9,31.8,54.8,32.1,55.3c1.6,2.6,3.7,3.9,5.7,3.3
                                    c1.3-0.3,2.8-1.6,2.8-3.9v-129h-19.1v76.8c0,0-31.8-54.8-33.3-57.3c-20.2-34.3-58.4-20.1-58.4,9.4v47.9c0,0-31.8-54.8-33.3-57.3
                                    c-20.2-34.3-58.4-20.1-58.4,9.4v78.5c0,2.9-2.1,5.3-5.3,5.3h-30C104.5,253.8,89.5,238.8,89.5,220.3z"/>
                                    <path
                                        style={{ fill: '#FFFFFF' }}
                                        d="M368.3,141.1v129c0,5.4-3.4,9.9-8.4,11.3c-0.9,0.2-1.9,0.4-3,0.4c-3.8,0-8.2-1.9-11.3-7.2
                                    c-0.2-0.3-12.8-22.1-32.1-55.3c-13.9-24-28.3-48.8-28.6-49.2c-1.6-2.6-3.7-3.9-5.7-3.3c-1.3,0.3-2.7,1.6-2.7,3.9V270
                                    c0,5.4-3.4,9.9-8.4,11.3c-4.3,1.2-10.3,0-14.3-6.8c-0.2-0.3-11.9-20.5-29.8-51.4c-15-25.9-30.5-52.6-30.8-53.1
                                    c-1.6-2.6-3.7-3.9-5.7-3.3c-1.3,0.3-2.8,1.6-2.8,3.9l0,97.4c0,6.7-5.9,12.6-12.6,12.6l-49.4,0c-33.2,0-60.2-27-60.2-60.2
                                    c0-33.2,27-60.2,60.2-60.2h25.7v-19h-25.6c-43.7,0-79.2,35.5-79.2,79.2c0,43.7,35.5,79.2,79.2,79.2h49.9c19,0,31.2-11.1,31.1-31.6
                                    v-45.2c0,0,31.8,54.8,33.3,57.3c20.2,34.3,58.4,20.1,58.4-9.4v-47.9c0,0,31.8,54.8,33.3,57.3c20.2,34.3,58.4,20.1,58.4-9.4V141.1
                                    H368.3z"/>
                                </svg>
                            </xml>
                        </a>

                        <div className="cnn-bar__content-by">
                            Content by <a href="https://www.incredibleindia.org/" target="_blank" rel="noopener sponsored">Ministry of Tourism India</a>
                        </div>

                        <div className="cnn-bar__share" data-share>
                            <a className="cnn-bar__share-toggle" data-share-toggle>
                                Share
                            </a>
                            <div className="cnn-bar__share-icons">
                                <a className="share-link share-link--facebook" target="_blank" rel="noopener noreferrer" href={`https://www.facebook.com/sharer/sharer.php?u=https://sponsorcontent.cnn.com/edition/2021/explore-incredible-india${location.pathname}`}>
                                    <xml version="1.0" encoding="utf-8">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 10">
                                            <path style={{ fill: '#FFFFFF' }} d="M4.4 5H3v5H1V5H0V3.2h1V2.1C1 1.3 1.4 0 3 0h1.5v1.7h-1c-.2 0-.5.1-.5.5v1h1.6L4.4 5z" />
                                        </svg>
                                    </xml>
                                </a>
                                <a className="share-link share-link--twitter" target="_blank" rel="noopener noreferrer" href={`https://twitter.com/intent/tweet?url=https://sponsorcontent.cnn.com/edition/2021/explore-incredible-india${location.pathname}`}>
                                    <xml version="1.0" encoding="utf-8">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 8">
                                            <path style={{ fill: '#FFFFFF' }} d="M8.8 1.9v.3c0 2.6-2 5.6-5.8 5.6-1 0-2.1-.3-3-.9 1.1.1 2.1-.2 3-.8-.9 0-1.6-.6-1.9-1.4.3.1.6 0 .9 0-.9-.2-1.6-1-1.6-1.9.2.1.5.2.9.2-.6-.4-.9-1-.9-1.6 0-.4.1-.7.3-1 1 1.2 2.5 2 4.2 2.1 0-.1-.1-.3-.1-.5 0-1.1.9-2 2-2 .6 0 1.1.2 1.5.6.5-.1.9-.2 1.3-.5-.2.5-.5.9-.9 1.1.4 0 .8-.2 1.2-.3-.3.4-.7.8-1.1 1z" />
                                        </svg>
                                    </xml>
                                </a>
                                <a className="share-link share-link--linkedin" target="_blank" rel="noopener noreferrer" href={`https://www.linkedin.com/shareArticle?mini=true&url=https://sponsorcontent.cnn.com/edition/2021/explore-incredible-india${location.pathname}`}>
                                    <xml version="1.0" encoding="utf-8">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
                                            <path style={{ fill: '#FFFFFF' }} d="M.1 9.6h2.2V3.1H.1v6.5zM1.2 0C.5 0 0 .5 0 1.1c0 .6.5 1.1 1.2 1.1.8 0 1.2-.5 1.2-1.1C2.4.4 1.9 0 1.2 0zM10 5.9v3.7H7.9V6.1c0-.9-.3-1.5-1.1-1.5-.6 0-1 .4-1.1.8-.1.2-.1.4-.1.5v3.7H3.4V3.1h2.2V4c.3-.4.8-1.1 1.9-1.1 1.5 0 2.5 1 2.5 3z" />
                                        </svg>
                                    </xml>
                                </a>
                            </div>
                        </div>

                    </div>
                </header>
            </section>

            <section className="demo-content">
                {props.content}
            </section>

        </div >
    );
};

export default GoldBar;